import React from 'react';
import { Link } from 'react-router-dom';
import { useCurrentOrganization } from '../store/organization';

function OrganizationLink(props) {
  const { currentOrganization } = useCurrentOrganization();
  const { to, ...restProps } = props;

  return <Link {...restProps} to={`/${currentOrganization.slug}${props.to}`} />;
}

export default OrganizationLink;
